// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3RlR0","container":"styles_container__9Ek4q","title":"styles_title__1Dzra","wrapper":"styles_wrapper__2UUl2","answer":"styles_answer__3H0ju"};